function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
import map from 'lodash/fp/map';
import concat from 'lodash/fp/concat';
import intersection from 'lodash/intersection';
import { mapState, mapGetters } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    type: function type(s) {
      return s.elements.type;
    },
    distance: function distance(s) {
      return s.elements.distance;
    }
  })), mapGetters({
    resultType: 'api/formResultType'
  })), {}, {
    currentResultElements: function currentResultElements() {
      return intersection(this.$ncsConfig.result[this.resultType].elements.types, this.$ncsConfig.elements.types);
    },
    currentResultDistances: function currentResultDistances() {
      return this.$ncsConfig.result[this.resultType].elements.distances;
    },
    options: function options() {
      var distances = this.currentResultDistances ? map(function (e) {
        return {
          type: e,
          distance: true
        };
      })(this.currentResultElements) : [];
      var elements = map(function (e) {
        return {
          type: e
        };
      })(this.currentResultElements);
      var all = concat(elements)(distances);
      return map(function (e) {
        return "".concat(e.type).concat(e.distance ? '-distance' : '');
      })(all);
    },
    isDisabled: function isDisabled() {
      return this.options.length === 0;
    },
    selected: {
      get: function get() {
        return this.distance.type ? "".concat(this.type, "-distance") : this.type;
      },
      set: function set(v) {
        var _v$split = v.split('-'),
            _v$split2 = _slicedToArray(_v$split, 2),
            type = _v$split2[0],
            distance = _v$split2[1];

        this.$store.dispatch('elements/setSearchType', {
          type: type,
          distance: distance ? 'eq' : null
        });
      }
    }
  }),
  // TODO: Check if this watcher is still needed for RERCOR.
  watch: {
    isDisabled: {
      immediate: true,
      handler: function handler(value) {
        if (value) {
          this.$store.dispatch('elements/setSearchType', {
            type: null,
            distance: null
          });
        } else {
          var defaultDistance = this.$ncsConfig.result[this.resultType].elements.defaultDistance;
          this.$store.dispatch('elements/setSearchType', {
            type: this.$ncsConfig.result[this.resultType].elements.defaultType,
            distance: defaultDistance ? defaultDistance.type : null
          });
        }
      }
    }
  }
};